import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e9446c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode()
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle" }

import { onMounted, ref, watch } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import { EnvironmentOutlined } from "@ant-design/icons-vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { bindEmitter } from "@/utils/emitter";
import { useRoute } from "vue-router";
import { Form } from "ant-design-vue";
interface Option {
  address: string; //地址 省市区
  city: string; // 市
  district: string; //区
  province: string; //省
  title: string; //地点名称
  id: number;
  adcode: number; //行政区划代码
  location: any; //提示所述位置坐标
}

import { defineComponent } from "vue";
const __default__ = defineComponent({
  isGlobal: true,
  name: "KeywordMapInput",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: String,
    default: "",
  },
  provinceId: {
    type: [Number, String],
    default: 0,
  },
  cityId: {
    type: [Number, String],
    default: 0,
  },
  districtId: {
    type: [Number, String],
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "请选择",
  },
  class: {
    type: String,
    default: "append-to-parent",
  },
  maxlength: {
    type: [Number, String],
    default: 100,
  },
  hasPCD: {// 返回数据是否包括省市区
    type: Boolean,
    default: false,
  },
},
  emits: [
  "update:value",
  "update:provinceId",
  "update:cityId",
  "update:districtId",
  "changeLocation",
],
  setup(__props, { emit }) {

const props = __props


const route = useRoute();

const locationOptions = ref("");
let suggest;
const onSelect = (value, option) => {
  // console.log("🚀 ~ file: index.vue:33 ~ onSelect ~ value,option:", value, option);
};
const formItemContext = Form.useInjectFormItemContext();
const selectedValue = (item) => {
  if(props.hasPCD){
    inputValue.value =item.address+ item.title;
  }else{
    inputValue.value = item.title;

  }
 
  emit("update:value", inputValue.value);
  // emit("update:provinceId", 2);// 修改详细地址地图带过来时省市区默认传0
  // emit("update:cityId", 2);
  // emit("update:districtId", 0);
  emit("changeLocation", {
    province: item.province,
    city: item.city,
    district: item.district,
  });
  formItemContext.onFieldChange();
};
const inputValue = ref("");
const onChange = async (key) => {
  if (key && suggest) {
    suggest.setCity(locationOptions.value ?? "");
    suggest.search(key, (status, result) => {
      if (status === "complete" && result.tips) {
        options.value = (result.tips || []).map((tip: any) => ({
          ...tip,
          title: tip.name || tip.title,
          address: tip.district || tip.address || "",
          province: "",
          city: "",
          district: tip.district || "",
        }));
      } else {
        options.value = [];
      }
    });
  }
};
const onSearch = (value) => {
  // console.log("🚀 ~ file: index.vue:70 ~ onSearch ~ value:", value);
  emit("update:value", value);
  formItemContext.onFieldChange();
};
const onBlur = () => {
  emit("update:value", inputValue.value);
  formItemContext.onFieldChange();
};
const options = ref<Option[]>([]);
const handleKeyPress = (ev: KeyboardEvent) => {
  // console.log("handleKeyPress", ev);
  // inputValue.value=ev;
};
// 清楚form表单数据
bindEmitter("change-location-region" + (route.name as string), (name) => {
  // console.log("🚀 ~ file: index.vue:96 ~ bindEmitter ~ name:", name, route.name);
  if (name) {
    locationOptions.value = name["city"].name;
    // // console.log(
    //   "🚀 ~ file: index.vue:95 ~ bindEmitter ~ locationOptions.value:",
    //   locationOptions.value
    // );
  } else {
    locationOptions.value = "";
  }

  inputValue.value = "";
  options.value = [];
});

watch(
  () => props.value,
  (n) => {
    inputValue.value = n;
  },
  {
    immediate: true,
  }
);
onMountedOrActivated(async () => {
  try {
     // 配置安全密钥,自2021年12月02日升级，升级之后所申请的 key 必须配备安全密钥 jscode 一起使用
    (window as any)._AMapSecurityConfig = {
      securityJsCode: 'ea641db5672f364bc68be3b2d6aaf0ae',
    };

    const AMap = await AMapLoader.load({
      key: "1709d24bcacbe87d1f95ac5ff204eec6",
      version: "2.0",
      plugins: ["AMap.AutoComplete"],
    });
    suggest = new AMap.AutoComplete({
      pageSize: 20,
    });
  } catch (error) {
    console.error("高德地图 API 加载失败:", error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!

  return (_openBlock(), _createBlock(_component_a_auto_complete, {
    value: inputValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
    class: _normalizeClass(["append-to-parent", __props.class]),
    disabled: __props.disabled,
    placeholder: __props.placeholder,
    onSelect: onSelect,
    onSearch: onSearch,
    onChange: onChange,
    options: options.value,
    onBlur: onBlur
  }, {
    option: _withCtx((item) => [
      _createElementVNode("div", {
        onClick: ($event: any) => (selectedValue(item))
      }, [
        _createVNode(_unref(EnvironmentOutlined)),
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(item.province) + " " + _toDisplayString(item.city ?? "") + " " + _toDisplayString(item.district ?? ""), 1)
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        onKeypress: handleKeyPress,
        "show-count": "",
        allowClear: "",
        maxlength: __props.maxlength
      }, null, 8, ["maxlength"])
    ]),
    _: 1
  }, 8, ["value", "class", "disabled", "placeholder", "options"]))
}
}

})